<div class="medpace-table">
    <div [ngClass]="isCard ? 'c-card' : ''" class="flex flex-col gap-medpace">
        <div class="c-card__header">
            @if (title) {
                <div class="c-card__ribbon">
                    <div class="c-card__item c-card__item--left">
                        <h3>{{ title }}</h3>
                    </div>
                </div>
            }
            <div class="c-card__ribbon">
                <div class="c-card__item c-card__item--right">
                    @if (ifFiltering && filterableData?.data?.length > 0) {
                        <div>
                            <mds-dropdown
                                [closeOnPageScroll]="false"
                                [appearance]="'outline'"
                                [multiple]="true"
                                [label]="searchPlaceholder"
                                placeholder="Select filter..."
                                [options]="filterOptions"
                                id="filterDropdown"
                                [matTooltip]="filterOptions?.length === 0 ? 'No filter options' : ''"
                                (selectionChange)="emitChange($event)"
                            ></mds-dropdown>
                        </div>
                    }

                    @if (isSearching) {
                        <div class="searchBar">
                            <mds-text-field
                                id="tableSearch"
                                data-cy="table-search"
                                appearance="outline"
                                label="Search"
                                placeholder="Type here..."
                                startIcon="search"
                                (keyup)="applyFilter($event)"
                            ></mds-text-field>
                        </div>
                    }
                </div>
            </div>
        </div>
        @if (showFilters) {
            <mds-divider [ngClass]="{ hidden: filterableData?.data?.length === 0 }" />
            <selected-custom
                [ngClass]="{ hidden: filterableData?.data?.length === 0 }"
                [data]="_data"
                (filterClickEvent)="filterClickEvent($event)"
                (resetDataClickEvent)="resetDataClickEvent()"
            />
        }
        <div class="table-content">
            <div class="c-table" [ngClass]="{ hidden: loadSpinner }">
                <mds-table
                    [dataSource]="filterableData"
                    [hasCustomRowDefs]="true"
                    [dataWhiteSpace]="'nowrap'"
                    matSort
                    [matSortActive]="defaultSorting?.columnName"
                    [matSortDirection]="defaultSorting?.direction"
                    [noDataMessage]="
                        filterableData?.data?.length > 0
                            ? 'No data found matching the filter.'
                            : 'No data available in table.'
                    "
                    (matSortChange)="OnSortChange()"
                >
                    @for (column of fieldMap(); track column) {
                        <ng-container [matColumnDef]="column.name">
                            <mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                                sortActionDescription="Sort by {{ column.name }}"
                                >{{ column.header }}</mat-header-cell
                            >
                            <mat-cell
                                *matCellDef="let element"
                                mat-cell
                                class="medpace-cell"
                                [ngClass]="setMatCellClass(element, column.name)"
                            >
                                <!-- element.request will not be empty when it's a requests table (AllRequests/PatientOverview) -->
                                @if (column.name === 'status' && element.request && element.request.flaggedDuplicate) {
                                    <div class="flex gap-1">
                                        <span>
                                            {{ element[column.name] }}
                                        </span>
                                        <div
                                            class="w-[28px] m-auto shrink-0"
                                            [matTooltipClass]="'duplicate-tooltip'"
                                            [matTooltipPosition]="'left'"
                                            [matTooltip]="duplicateInfo()"
                                        >
                                            <mat-icon class="dupeIcon" (mouseenter)="getDuplicateInfo(element)"
                                                ><img
                                                    alt="Potential Duplicate"
                                                    class="duplicate-red-icon"
                                                    src="/../../assets/img/duplicate-icn.png"
                                                />
                                            </mat-icon>
                                        </div>
                                    </div>
                                } @else {
                                    {{ element[column.name] }}
                                }
                            </mat-cell>
                        </ng-container>
                    }
                    <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
                    <mat-row
                        (click)="OnRowClick(row)"
                        *matRowDef="let row; columns: columns"
                        [class.mdc-data-table__row-removed]="isDeletedPropertyName && row[isDeletedPropertyName]"
                        [attr.title]="GetTitle(row)"
                    ></mat-row>
                </mds-table>
            </div>
            @if (loadSpinner) {
                <div class="spinnerOverlay">
                    <medpace-loading-card [diameter]="100" />
                </div>
            }
            <mds-paginator #tablePaginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" />
        </div>
    </div>
</div>
